import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "shift-detail-form-row",
  templateUrl: "./shift-detail-form-row.component.html",
  styleUrls: ["./shift-detail-form-row.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftDetailFormRowComponent implements OnInit, OnDestroy {
  @Input() formGroup!: FormGroup;
  @Input() weekdays: { label: string; value: number }[] = [];
  @Input() weeks: { label: string; value: number }[] = [];
  @Input() refreshTick: 0;
  @Output() remove = new EventEmitter<void>();

  private sub?: Subscription;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.sub = this.formGroup.statusChanges.subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
